<template>
  <div class="venue container" v-loading="container">
    <el-image 
      style="width: 1200px; height: 660px"
      :src="isHead(info.imgpath1)" 
      fit="cover">
      <el-image 
        style="width: 1200px; height: 660px"
        :src="isHead()" 
        fit="cover">
      </el-image>
    </el-image>
    <div style="height: 50px"></div>
    <div class="title">{{info.title}}</div>
    <div style="height: 30px"></div>
    <div class="time">负责人：{{info.contacts}}</div>
    <div style="height: 30px"></div>
    <div class="time">联系电话：{{info.tel}}</div>
    <div style="height: 30px"></div>
    <div class="time">地址：{{info.address}}</div>
    <div style="height: 30px"></div>
    <div class="content" v-html="info.content"></div>
    <div style="height: 50px"></div>
  </div>
</template>

<script>
import { reactive, toRefs } from "vue"
import { useRoute } from 'vue-router'
import { api } from "@/api"
import { isHead, formatTime } from "@/tools"
export default {
  name: "venue",
  setup() {
    const route = useRoute()
    let initData = reactive({
      info: "",
      loading: true
    })
    api("get", "getVenueInfo", {aid: route.query.id, tyep: route.query.type}).then(res => {
      initData.loading = false
      if(res.code === 1200) {
        initData.info = res.data
      }
    })
    return {
      ...toRefs(initData),
      isHead,
      formatTime
    }
  }
}
</script>

<style lang="less" scoped>
.title {
  font-size: 26px;
  font-weight: bold;
}
.time {
  color: #8C96A1;
}
.content {
  border-top: 1px solid #EAEAEA;
  padding: 20px 0;
  box-sizing: border-box;
  background-color: white;
  :deep(img) {
    max-width: 100% !important;
    height: auto !important;
  }
}
</style>